export const createSubCompany = `mutation CreateSubCompany($input: CreateSubCompanyInput!) {
    createSubCompany(input: $input) {
      id
      companyId
      keywords
      name
    }
  }
  `;
